import React, { Component } from 'react';

import { showModal } from '../actions/modal';

import { trackEvent } from '../services/events-tracker-service';

import Tooltip from './tooltip';

export default class TaskCreateCTA extends Component {
    handleClick = () => {
        showModal('CREATE_TASK_SIMPLE', {
            name: this.props.getName(),
            projectId: this.props.projectId
        });

        trackEvent('DISCUSSION.TASK_CREATE')
    }

    render() {
        return (
            <Tooltip tooltip="Create a Task">
                <button className="btn btn-square btn-xxsmall btn-simple btn-icon" onClick={this.handleClick}>
                    <i className="material-icons">playlist_add</i>
                </button>
            </Tooltip>
        )
    }
}
